<template>
    <div :class="['bxs-alert', {
        ['bxs-alert-' + type]: type
    }]"
    @click="on = true">
        <bxs-icon
        v-if="icon_name"
        width="1.25em"
        height="1.25em"
        :name="icon_name" />

        <div class="flex-1">
            <slot />
        </div>

        <bxs-menu
        v-if="$slots.details"
        v-model="on"
        title="Avviso"
        solo>
            <div class="pa-layout">
                <slot name="details" />
            </div>
        </bxs-menu>
    </div>
</template>

<script>
export default {
    name: 'alert',
    props: {
        type: {
            type: String,
            required: false,
            default: 'info'
        }
    },
    data () {
        return {
            on: false
        }
    },
    computed: {
        icon_name () {
            let v = ''

            if (this.type === 'info') v = 'info-circle-fill'
            else if (this.type === 'warn' || this.type === 'warning') v = 'exclamation-triangle-fill'
            else if (this.type === 'error') v = 'exclamation-lg'

            return v
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/conf.scss';

$bg-lighten-perc: 30%;
$pin-darken-perc: 20%;
$color-darken-perc: 25%;

.bxs-alert {
    display: block;
    border-left: var(--alert-border-left-width) solid transparent;
    border-radius: var(--radius);
    padding: 0.75rem 1rem;
    font-weight: var(--alert-font-weight);
    font-size: 1rem;
    min-height: var(--alert-min-height);
    display: flex;
    flex-flow: row nowrap;

    &.bxs-alert-info {
        background-color: lighten(map-get($colors, 'info'), $bg-lighten-perc);
        border-left-color: darken(map-get($colors, 'info'), $pin-darken-perc);
        color: darken(map-get($colors, 'info'), $color-darken-perc);
    }

    &.bxs-alert-warn,
    &.bxs-alert-warning {
        background-color: lighten(map-get($colors, 'warn'), $bg-lighten-perc);
        border-left-color: darken(map-get($colors, 'warn'), $pin-darken-perc);
        color: darken(map-get($colors, 'warn'), $color-darken-perc);
    }

    &.bxs-alert-error {
        background-color: lighten(map-get($colors, 'error'), $bg-lighten-perc);
        border-left-color: darken(map-get($colors, 'error'), $pin-darken-perc);
        color: darken(map-get($colors, 'error'), $color-darken-perc);
    }

    > .bxs-icon {
        margin-right: var(--alert-icon-margin-x);
    }

    p {
        margin: 0;
        padding: 0;
    }
}
</style>